var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(this.active)?_vm._t("default"):_vm._e(),_vm._v(" "+_vm._s(_vm.remaining.seconds))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }